<template>
	<div>
		<el-table class="group-list" :height="height" :data="data" border :show-header="isHeader" @row-click="handleRowClick($event)">
			<el-table-column :label="$t('groupList.groupChat')">
				<template slot-scope="scope">
					<div class="container">
						<div class="left">
							<ChatAvatar type="group" size="35" borderRadius="50%" />
						</div>
						<div class="right">
							<div class="group-name" :title="scope.row.name">{{ scope.row.name }}</div>
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="tools-container">
			<el-button class="create-group" icon="el-icon-plus" size="small" @click="createGroupVisiable($event)">{{
				$t("groupList.createGroupChat")
			}}</el-button>
		</div>
		<SelectMember
			v-if="visiableAddMember"
			:membersId="membersId"
			@select-member-close-click="selectMemberClose()"
			:visiableAddMember="visiableAddMember"
			v-on:onSubmit="createGroupSubmit"
		>
			<el-row class="group-name-content">
				<el-col :span="3">
					<span>{{ $t("groupList.groupName") }}</span>
				</el-col>
				<el-col :span="10">
					<el-input size="mini" v-model="groupName" placeholder=""></el-input>
				</el-col>
			</el-row>
		</SelectMember>
	</div>
</template>

<script>
import ChatAvatar from "./chat-avatar.vue";

import SelectMember from "./select-member";

import { createGroup } from "@/services/api-v2/api-v2";

export default {
	components: {
		ChatAvatar,
		SelectMember,
	},

	name: "GroupList",

	props: {
		data: {
			type: Array,
			required: true,
		},
		height: {
			type: Number,
			required: false,
			default: null,
		},
		isHeader: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data() {
		return {
			visiableAddMember: false,
			membersId: [],
			groupName: "",
		};
	},

	methods: {
		// 显示选择成员窗口
		createGroupVisiable() {
			this.groupName = "";
			this.visiableAddMember = true;
		},

		// 关闭选择成员窗口
		selectMemberClose() {
			this.visiableAddMember = false;
		},

		// 创建群聊
		async createGroupSubmit(data) {
			const name = this.groupName ? this.groupName : data.group_name;
			createGroup(name, data.contacts_id).then(
				(response) => {
					this.data.push(response.data);
					this.visiableAddMember = false;
					this.$message({ message: "success", type: "success" });
				},
				(error) => {
					this.$message({ message: error.message, type: "error" });
					this.visiableAddMember = false;
				}
			);
		},

		// 列表点击
		handleRowClick(event) {
			this.$emit("row-click", event);
		},
	},
};
</script>

<style lang="less" scoped>
.container {
	display: flex;
	flex: 1;
	align-items: center;
	gap: 10px;
	cursor: pointer;
}

.left {
	display: flex;
}

.right {
	display: flex;
	flex: 1;

	.group-name {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 280px;
	}
}

.tools-container {
	display: flex;
	padding-top: 10px;
	justify-content: left;

	.create-group {
		width: 100%;
	}
}

.group-name-content {
	line-height: 30px;
	margin-bottom: 20px !important;
}
</style>
